import { Link } from "react-router-dom";
import { NOTES } from "../../content/sojournsNotes";
import { FollowGlyph } from "./Follow";

// Renders text with [label](/path) links as router links (or plain anchors for http).
export const Prose = ({ text }) => {
  const parts = text.split(/(\[[^\]]+\]\([^)]+\))/g);
  return parts.map((part, i) => {
    const m = part.match(/^\[([^\]]+)\]\(([^)]+)\)$/);
    if (!m) return part;
    const [, label, href] = m;
    return /^https?:/i.test(href)
      ? <a key={i} href={href} className="sj-link" target="_blank" rel="noopener noreferrer">{label}</a>
      : <Link key={i} to={href} className="sj-link">{label}</Link>;
  });
};

export const NoteHeader = ({ open }) => (
  <header className="sj-header" data-testid="sojourns-header">
    <div className="sj-col">
      <Link to="/sojourns" className="sj-wordmark" data-testid="sojourns-wordmark">
        <span className="savi">SAVI</span>
        <span className="rule" aria-hidden="true" />
        <span className="sojourns">Sojourns</span>
      </Link>
      <div className="sj-header-right">
        <FollowGlyph />
        <Link to="/sojourns#register" className="sj-header-link" data-testid="sojourns-header-register">{open ? "Apply now" : <><span className="sj-full">Register interest</span><span className="sj-short">Register</span></>}</Link>
      </div>
    </div>
  </header>
);

// Hairline list of questions and answers; the matching FAQPage JSON-LD comes from faqJsonLd().
export const Faq = ({ items, testid = "sojourns-faq" }) => (
  <dl className="sj-faq" data-testid={testid}>
    {items.map((f, i) => (
      <div className="sj-faq-item" key={f.q} data-testid={`${testid}-${i + 1}`}>
        <dt>{f.q}</dt>
        <dd><Prose text={f.a} /></dd>
      </div>
    ))}
  </dl>
);

export const faqJsonLd = (items) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: items.map((f) => ({ "@type": "Question", name: f.q, acceptedAnswer: { "@type": "Answer", text: f.a.replace(/\[([^\]]+)\]\([^)]+\)/g, "$1") } })),
});

// The six notes, numbered, as a reading list. `except` hides the one you're on.
export const NotesList = ({ except, testid = "sojourns-notes" }) => (
  <ul className="sj-notes" data-testid={testid}>
    {NOTES.filter((n) => n.slug !== except).map((n) => (
      <li key={n.slug}>
        <Link to={`/sojourns/${n.slug}`} data-testid={`${testid}-${n.slug}`}>
          <span className="n" aria-hidden="true">{n.n}</span>
          <span className="t">{n.title}</span>
          <span className="m">{n.minutes} min</span>
        </Link>
      </li>
    ))}
  </ul>
);
